<template>
	<div class="order-search-body">
		<div class="achieve-search">
			<div class="filters-box-row">
				<div class="filters-container">
					<div class="input-box">
						<el-select v-model="dateType" class="select-input" size='small'>
							<el-option :value="1" label="下单时间"></el-option>
							<el-option :value="0" label="生成时间"></el-option>
							<el-option :value="2" label="勾销时间"></el-option>
							<el-option :value="3" label="审核时间"></el-option>
						</el-select>
						<el-date-picker
							@change="searchTime"
							v-model="dateValue"
							:clearable="false"
							:unlink-panels='true'
							:default-time="['00:00:00', '23:59:59']"
							class="time-input"
							size="small"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format='yyyy-MM-dd HH:mm'
							value-format='yyyy-MM-dd HH:mm'>
						</el-date-picker>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>单号：</span>
						<el-input
							class="filter-input"
							v-model="number"
							placeholder="请输入订单/退单编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>员工名称：</span>
						<el-select v-model="staff" class="filter-input" size='small' filterable multiple collapse-tags>
							<el-option value="" label="全部"></el-option>
							<el-option v-for="item in staffList" :value="item.staffname" :label="item.staffname" :key="item.staffname"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户类别：</span>
						<el-select v-model="customerCategoryId" class="filter-input" size='small'>
							<el-option value="0" label="全部"></el-option>
							<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>勾销状态：</span>
						<el-select v-model="liquiDateFlag" class="filter-input" size='small'>
							<el-option :value="-1" label="全部"></el-option>
							<el-option :value="1" label="勾销"></el-option>
							<el-option :value="0" label="未勾销"></el-option>
						</el-select>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>客户名称：</span>
						<el-input
							class="filter-input"
							v-model="customer"
							placeholder="请输入客户信息"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>商品信息：</span>
						<el-input
							class="filter-input"
							v-model="product"
							placeholder="请输入商品名称/编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
				<div class="filters-container">
					<div class="input-box">
						<span>规格信息：</span>
						<el-input
							class="filter-input"
							v-model="spec"
							placeholder="请输入规格名称/编号"
							size="small"
							@keyup.enter.native="search">
						</el-input>
					</div>
				</div>
			</div>
			<div class="achieve-search-btn">
				<!-- <el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button> -->
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" v-if="AuthorityList['11_0002_0003_00']" @click="liquidate(1)">勾销</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="liquidate(0)">取消勾销</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="auditing(1)">已审核</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn" v-if="AuthorityList['11_0002_0003_00']" @click="auditing(0)">未审核</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
				<div></div>
				导出
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		staffList: {
			type: Array,
			default: () => []
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			collapse: false,
			dateType: 0,
			customerCategoryId: '0',
			number: '',
			staff: [],
			liquiDateFlag: -1,
			customer: '',
			product: '',
			spec: '',
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	created () {
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		if (this.$route.query.staff.length !== 0) {
			this.staff = this.$route.query.staff
		}
		if (this.$route.query.dateValue && this.$route.query.dateValue.length > 0) {
			this.dateValue = this.$route.query.dateValue
		} else {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		}
		if (window.sessionStorage.getItem('achieveDetailSelect') && !this.filterFlag) {
			let data = JSON.parse(window.sessionStorage.getItem('achieveDetailSelect'))
			this.dateValue = data.dateValue
			this.number = data.number
			this.dateType = data.dateType
			this.customerCategoryId = data.customerCategoryId
			this.staff = data.staff
			this.customer = data.customer
			this.product = data.product
			this.liquiDateFlag = data.liquiDateFlag
			this.spec = data.spec
		}
	},
	methods: {
		// 勾销
		liquidate (type) {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一条订单！')
				return false
			}
			let params = {
				liquidateflag: type,
				commissionResultIds: this.ids.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/liquidateflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('勾销失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		auditing (type) {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一条订单！')
				return false
			}
			let params = {
				auditingflag: type,
				commissionResultIds: this.ids.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/result/auditingflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error('审核失败，请稍后重试')
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		searchTime (value) {
			// window.sessionStorage.setItem('afterSearchTime', JSON.stringify(value))
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于12个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			if (this.checkTime()) {
				this.$emit('handleSearch', { customerCategoryId: this.customerCategoryId, number: this.number, customer: this.customer, dateValue: this.dateValue, staff: this.staff, product: this.product, dateType: this.dateType, liquiDateFlag: this.liquiDateFlag, spec: this.spec })
			}
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			// let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			// this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.number = ''
			this.customerCategoryId = '0'
			this.staff = ''
			this.customer = ''
			this.product = ''
			this.dateType = 0
			this.liquiDateFlag = -1
			this.spec = ''
			if (this.$route.query.staff) {
				this.staff = this.$route.query.staff
			}
			if (this.$route.query.dateValue) {
				this.dateValue = this.$route.query.dateValue
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.achieve-search {
	display: flex;
	justify-content: space-between;
	width :100%;
	line-height :50px;
}
.achieve-search-btn {
	width: 150px;
	flex-shrink: 0
}
.filters-box-row {
	display: flex;
	flex-wrap: wrap;
	box-sizing: border-box
	text-align: left
	.select-input {
		width: 100px;
	}
	&.filters-box-row3 {
		padding-top: 5px;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.input-box>span {
			display: inline-block;
			width: 105px;
			text-align: right;
		}
		.time-input {
			width: 430px;
			margin-left: 5px;
		}
		.filter-input {
			width: 160px
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
